/* eslint-disable @typescript-eslint/ban-ts-comment */
import { motion } from "framer-motion";
import CartIcon from "../Icons/CartIcon";
import CloseIcon from "../Icons/CloseIcon";
import { useEffect, useState } from "react";
import CoursePlaceholder from "../../assets/CoursePlaceholder.png";
import { getUserCountry } from "../../utils/utils";
import TrashIcon from "../Icons/TrashIcon";
import { useMutation, useQuery } from "@tanstack/react-query";
import { GetCart } from "../../api/Cart/GetCart";
import { DeleteCartItem } from '../../api/Cart/DeleteCartItems';
import { queryClient } from "../../main";
import { toast } from "react-toastify";
import { DeleteCartPackage } from "../../api/Cart/DeletePackageFromCart";
import Button from "./Button";
import { Link } from "react-router-dom";
import { DeleteCartBook } from "../../api/Cart/DeleteBookFromCart";
import { useUserDataStore } from "../../stores/user";
const Cart = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const { userData } = useUserDataStore();
    const { data: CartData } = useQuery({
        queryFn: GetCart,
        queryKey: ["cart"],
        staleTime: 0,
        refetchInterval: 0,
        enabled: !!userData.id && userData.role !== "sales" && userData.role !== "admin"
    });
    const { mutate: DeleteCart } = useMutation({
        mutationFn: DeleteCartItem,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["cart"] });
            toast.success("Course Removed from cart successfully");
        },
    });
    const { mutate: DeletePackageCart } = useMutation({
        mutationFn: DeleteCartPackage,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["cart"] });
            toast.success("Package Removed from cart successfully");
        },
    });
    const { mutate: DeleteBookCart } = useMutation({
        mutationFn: DeleteCartBook,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["cart"] });
            toast.success("Book Removed from cart successfully");
        },
    });

    const cart = CartData?.data;
    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    const sidebarVariants = {
        open: { x: 0 },
        closed: { x: "100%" },
    };
    const [country, setCountry] = useState<string | null>(null);

    useEffect(() => {
        const userCountry = getUserCountry();
        setCountry(userCountry);
    }, []);
    const hasItems = (cart?.courses?.length ?? 0) > 0 || (cart?.packages?.length ?? 0) > 0 || (cart?.books?.length ?? 0) > 0;
    const itemsLength = cart ? cart?.courses?.length + cart?.books?.length + cart?.packages?.length : 0
    return (
        <>
            <div className="fixed bottom-7 left-7 z-[999999999]">
                <button
                    onClick={toggleSidebar}
                    className="relative p-3 bg-white border-2 shadow-md sm:p-4 rounded-xl sm:rounded-2xl"
                >
                    <span className="absolute flex items-center justify-center font-bold text-center text-white border border-white rounded-full size-7 -top-2 -right-2 bg-primary">{itemsLength}</span>
                    <CartIcon className="sm:size-auto size-8" />
                </button>
            </div>
            <motion.div
                className={`fixed inset-0 bg-black bg-opacity-50 z-40  ${isSidebarOpen ? 'md:hidden' : 'hidden'}`}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.3 }}
                onClick={toggleSidebar}
            />
            <motion.div
                className="flex overflow-y-scroll flex-col bg-white fixed z-[99999999999999] top-0 justify-between right-0 h-full shadow-lg p-5 lg:w-[40%] md:w-[60%] sm:w-[70%] w-[90%] xl:w-[30%]"
                variants={sidebarVariants}
                initial="closed"
                animate={isSidebarOpen ? "open" : "closed"}
                transition={{
                    ease: "linear",
                    duration: 2,
                    x: { duration: 0.3 },
                }}
            >
                <button onClick={toggleSidebar} className="self-end">
                    <CloseIcon />
                </button>
                <div className="mb-auto">
                    <h2 className="mb-4 text-xl font-semibold">Cart</h2>
                    {cart?.courses ?
                        cart.courses.map((course) => (
                            <div key={course.id} className="flex gap-4 mb-4">
                                <img
                                    src={course.img_url}
                                    alt="course"
                                    className="rounded-lg sm:size-24 size-16"
                                />
                                <div className="flex flex-col justify-between w-full">
                                    <div className="flex items-end justify-between">
                                        <h3 className="text-sm font-bold md:text-lg">{course.name}</h3>
                                        <button onClick={() => DeleteCart(course.id)} className="text-red-500">
                                            <TrashIcon />
                                        </button>
                                    </div>
                                    <div className="rounded py-1.5 w-[90px] px-3 flex justify-center md:text-base text-sm items-center gap-0.5 font-bold bg-primary text-white">
                                        {country === "EG" ? (
                                            <>
                                                {course.discountPrice_egp
                                                    ? course.discountPrice_egp
                                                    : course.actualPrice_egp}{" "}
                                                <sub className="text-xs uppercase md:text-sm">
                                                    EGP
                                                </sub>
                                            </>
                                        ) : (
                                            <>
                                                {course.discountPrice_usd
                                                    ? course.discountPrice_usd
                                                    : course.actualPrice_usd}{" "}
                                                <sub className="text-xs uppercase md:text-sm">
                                                    USD
                                                </sub>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )) : (
                            <>
                                <h1 className="text-lg font-bold">Your cart is empty, Add something to it</h1>
                            </>
                        )}
                    {cart?.packages &&
                        cart.packages.map((pack) => (
                            <div key={pack.id} className="flex gap-4 mb-4">
                                <div className="sm:min-w-24 min-h-16 sm:min-h-24 min-w-16 sm:max-w-24 max-w-16 flex gap-0.5 rounded-lg overflow-hidden">

                                    {pack.courses.map((course, index) => (
                                        <img
                                            key={index}
                                            src={course.img_url || CoursePlaceholder}
                                            className={`${index === 1 ? 'object-right' : 'object-left'} w-1/2 h-full object-cover sm:max-w-24 sm:max-h-24 max-h-16 max-w-16`}
                                        />
                                    ))}
                                </div>
                                <div className="flex flex-col justify-between w-full">
                                    <div className="flex items-end justify-between">
                                        <h3 className="text-sm font-bold md:text-lg">{pack.name}</h3>
                                        <button onClick={() => DeletePackageCart(pack.id)} className="text-red-500">
                                            <TrashIcon />
                                        </button>
                                    </div>

                                    <div className="rounded py-1.5 w-[90px] px-3 flex justify-center md:text-base text-sm items-center gap-0.5 font-bold bg-primary text-white">
                                        {country === "EG" ? (
                                            <>
                                                {pack.discountPrice_egp
                                                    ? pack.discountPrice_egp
                                                    : pack.actualPrice_egp}{" "}
                                                <sub className="text-xs uppercase md:text-sm">
                                                    EGP
                                                </sub>
                                            </>
                                        ) : (
                                            <>
                                                {pack.discountPrice_usd
                                                    ? pack.discountPrice_usd
                                                    : pack.actualPrice_usd}{" "}
                                                <sub className="text-xs uppercase md:text-sm">
                                                    USD
                                                </sub>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        ))}
                    {cart?.books ?
                        cart.books.map((book) => (
                            <div key={book.id} className="flex gap-4 mb-4">
                                <img
                                    src={book.img_url}
                                    alt="course"
                                    className="rounded-lg sm:size-24 size-16"
                                />
                                <div className="flex flex-col justify-between w-full">
                                    <div className="flex items-end justify-between">
                                        <h3 className="text-sm font-bold md:text-lg">{book.name}</h3>
                                        {/* @ts-expect-error */}
                                        <button onClick={() => DeleteBookCart(book.id)} className="text-red-500">
                                            <TrashIcon />
                                        </button>
                                    </div>
                                    <div className="rounded py-1.5 w-[90px] px-3 flex justify-center md:text-base text-sm items-center gap-0.5 font-bold bg-primary text-white">
                                        {country === "EG" ? (
                                            <>
                                                {book.discountPrice_egp
                                                    ? book.discountPrice_egp
                                                    : book.public_EGP_price}{" "}
                                                <sub className="text-xs uppercase md:text-sm">
                                                    EGP
                                                </sub>
                                            </>
                                        ) : (
                                            <>
                                                {book.discountPrice_usd
                                                    ? book.discountPrice_usd
                                                    : book.public_USD_price}{" "}
                                                <sub className="text-xs uppercase md:text-sm">
                                                    USD
                                                </sub>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )) : ('')}

                </div>

                {hasItems &&
                    <Link to={`/cart-checkout`} className="w-full">
                        <Button onClick={toggleSidebar} variant="primary" className="w-full md:!h-16 !h-12 md:text-xl !text-base">Checkout</Button>
                    </Link>
                }
            </motion.div>
        </>
    );
};

export default Cart;
